import {flow, getEnv, getType, types} from "mobx-state-tree";
import { FormattedMessage } from "react-intl";
import React from "react";
import lodash from "lodash";
import {UserModel} from "../../../models/users/userModel";

export const MediaFilterSelectState = types.model('MediaFilterSelectState',{
  selectStateUuid: types.maybe(types.identifier),
  statusTypes: types.optional(types.array(types.string), []),
  userEmails: types.optional(types.array(UserModel), []),
  isDisabled: types.optional(types.boolean, false),
}).volatile(self => ({
  notifySelect: types.f,
  selected: types.array,
  fileFormat: types.array,
  usage: types.array,
})).actions((self)=>({
  populateAllFilters: flow(function* (sortParams = {}) {
    try {
      const queryParams = {
        ...sortParams
      };

      const response = yield getEnv(self).mediaFileManager.fetchAllFilters(queryParams);
      if (response) {
        self.setEmails(response?.users || []);
        self.setCodeTypes(response?.fileFormat || []);
        self.setStatusTypes(response?.status || []);
        self.setBehaviorTypes(response?.content || []);
      }
    }
    catch (error) {
      console.error('Failed to populateAllFilters: ', error);
    }
  }),
  reset(){
    self.selected = []
    self.setIsDisabled(false);
  },
  setIsDisabled(d) {
    self.isDisabled = d;
  },
  setEmails(users) {
    self.userEmails = users
  },
  setFileFormat(types) {
    self.fileFormat = types
  },
  setStatusTypes(status) {
    self.statusTypes = status
  },
  setUsage(usage) {
    self.usage = usage
  },
  filterChange(data){
    self.selected = data;
    self.notifySelect(lodash.reduce(data, function(result, value, key) {
      const parts = value.value.split('.');
      const pushValue = parts[parts.length-1];
      const fieldName = value.value.substr(0, value.value.length - pushValue.length - 1 );
      (result[fieldName] || (result[fieldName] = [])).push(pushValue);
      return result;
    }, {}), ["fileFormat","status","content", "createdBy"]);
  },
  setConsumer(f){
    self.notifySelect = f
  },
  afterCreate() {
    console.log("Instantiated " + getType(self).name)
    self.notifySelect = (data) => {
      console.log("placeholder notifySelect")
    }
  }

})).views( (self) => ({
  optionValues() {
    const fileFormatOptions = self?.fileFormat?.slice()
      .sort((a, b) => a?.localeCompare(b))
      .flatMap( (stat) =>{
        return {
          label: stat,
          value: "fileFormat."+stat
        }
      });;

    const statusOptions = self?.statusTypes?.slice()
      .sort((a, b) => a?.localeCompare(b))
      .flatMap( (stat) =>{
        return {
          label: stat,
          value: "status."+stat
        }
      });

    const contentOptions = self?.usage?.slice()
      .sort((a, b) => a?.localeCompare(b))
      .flatMap( (stat) =>{
        return {
          label: stat,
          value: "usage."+stat
        }
      });

    const userEmails = self?.userEmails || [];
    const userOptions = userEmails
      .slice()
      .sort((a, b) => a?.email?.localeCompare(b?.email)) // Sort the copied array by email
      .flatMap((user) => ({
        label: user?.email,
        value: "createdBy." + user.uuid
      }));

    const options = [
      {
        label: <FormattedMessage id="mediaFile.filter.filterBy.fileFormat.defaultMessage"/>,
        options: fileFormatOptions
      },
      {
        label: <FormattedMessage id="mediaFile.filter.filterBy.status.defaultMessage"/>,
        options: statusOptions
      },
      {
        label: <FormattedMessage id="mediaFile.filter.filterBy.usage.defaultMessage"/>,
        options: contentOptions
      },
      {
        label: <FormattedMessage id="mediaFile.filter.filterBy.users.defaultMessage"/>,
        options: userOptions
      }
    ];
    return options;
  }
}))
